import { Outlet } from 'react-router-dom';
import LegalFooter from 'components/shared/legalFooter';

export default function ExploreLayout() {
  return (
    <>
      <div className="explore-wrapper">
        <Outlet />
      </div>
      <LegalFooter />
    </>
  );
}
